import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'sizeFormat'})
export class SizeFormatPipe implements PipeTransform {
  transform(
    size: number,
    decimals: number = 2,
    binary: boolean = false,
    showSuffix: boolean = true,
    fixedUnit?: string // e.g., 'KB', 'MB', 'GiB'
  ): string {
    if (isNaN(size) || size < 0) return '?';
    if (size === 0) return showSuffix ? '0 B' : '0';

    const base = binary ? 1024 : 1000;
    const units = binary
      ? ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB']
      : ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];

    let index = Math.floor(Math.log(size) / Math.log(base));

    if (fixedUnit) {
      const targetIndex = units.findIndex(u => u.toLowerCase() === fixedUnit.toLowerCase());
      if (targetIndex !== -1) {
        index = targetIndex;
      }
    }

    const value = parseFloat((size / Math.pow(base, index)).toFixed(decimals));
    return showSuffix ? `${value} ${units[index]}` : `${value}`;
  }
}